// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"tca-z","narrowOptionButtons":"uca-z","noOptions":"vca-z"};